import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "it"],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    // Without an explicit `ns`, i18next still requests the built-in
    // "translation" namespace at init even when defaultNS is set. The
    // shipped locale files are `common.json`; listing it here stops
    // i18next from also fetching the missing translation.json.
    ns: ["common"],
    defaultNS: "common",
    fallbackLng: ["en", "it"],
  });

export default i18n;
